import * as Yup from "yup";

// Mirrors AdminResetPasswordValidationClass on the api
export const ResetUserPasswordFormValidation = Yup.object({
    password: Yup.string()
        .min(8, "Password must be at least 8 characters long.")
        .matches(
            /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).+$/,
            "Password must include at least one uppercase letter, one number, and one special character."
        )
        .required("Password is required"),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref("password")], "Passwords do not match")
        .required("Please confirm the password"),
    sendEmail: Yup.boolean(),
});
